var exports = {
  "S": "xae11d333--48fb6d--image",
};

module.exports = exports;
